<script setup lang="ts">
import IconTabBarDialogs from '@/shared/assets/icons/IconTabBarDialogs.svg'
import { Counter } from '@/shared/ui/counter'

import CabHeaderNavWrap from './CabHeaderNavWrap.vue'

defineProps({
  to: {
    type: String,
    required: true,
  },
  count: {
    type: Number,
    required: false,
    default: 0,
  },
  inCall: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <CabHeaderNavWrap :to="to" :in-call="inCall" data-test="widget_header__button_messages">
    <div class="flex items-center justify-start">
      <IconTabBarDialogs class="h-24 w-24 fill-gray-500 lg:mr-6 lg:group-hover:fill-black" />
      <span class="mr-4 hidden lg:inline">{{ $t('header.messages') }}</span>
      <Counter
        class="absolute right-0 top-12 box-content border-2 border-solid border-white lg:static"
        :count="count"
      />
    </div>
  </CabHeaderNavWrap>
</template>
